import { useState } from 'react';
import { useHistory } from 'react-router';
import { ASSIST_SEARCH } from '@shared/helpers/routes';
import { useDispatch } from 'react-redux';
import {
  setFormNoViaja,
  setFormPassengers,
  setFormContact,
} from '@shared/redux/actions';

import Steps from '@shared/components/Steps/steps';
import { ConfirmDialogModal } from '@shared/components/Dialogs';

const PaymentsSteps = () => {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <Steps setShowModal={setShowModal} activeStep={3} />
      <ConfirmDialogModal
        isOpen={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
        onConfirm={() => {
          history.push(ASSIST_SEARCH);
          dispatch(setFormPassengers({ pasajeros: null }));
          dispatch(setFormNoViaja({ noViaja: null }));
          dispatch(setFormContact({ contact: null }));
          setShowModal(false);
        }}
        text="¿Estás seguro de salir? Se borrarán los datos cargados."
      />
    </>
  );
};
export default PaymentsSteps;
